import {
  Tooltip,
  Card,
  Typography,
  CardHeader,
  CircularProgress,
  Box,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  TextField,
  Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  deleteIndicator,
  approveIndicator,
  getIndicatorAssignments,
  downloadEmployeeContractReport,
  downloadEmployeePerformanceReport,
  changeRBMContractType,
} from "../../../store/rbm/actions";
import CustomProgressLine from "./CustomProgressLine";
import ContractForm from "./ContractForm";
import ContractDetailsDialog from "./ContractDetailsDialog";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { DownloadEmployeeRBMReport } from "./MonitorEmployeeCard";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

const SubordinateCard = (props) => {
  const {
    // selectedOutput,
    subordinate,
    // setIsEditing,
    // setShowIndicatorForm,
    // deleteIndicator,
    // approveIndicator,
    // user,
    // isChildIndicator,
    // getIndicatorAssignments,
    loading,
    downloadEmployeeContractReport,
    downloadEmployeePerformanceReport,
    selectedFiscalYear,
    changeRBMContractType,
    refreshOnChange,
  } = props;

  const [score, setScore] = useState(0);
  const [changeContractType, setChangeContractType] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setScore(subordinate.totalScore);
    }, 500);
  }, [subordinate]);

  const [showContractDialog, setShowContractDialog] = useState(false);
  const [showContractItemsDialog, setShowContractItemsDialog] = useState(false);
  const [contractType, setContractType] = useState(null);
  const [saving, setSaving] = useState(false);

  const saveChange = () => {
    if (!!contractType && !!changeContractType) {
      changeRBMContractType(
        {
          contractId: changeContractType.contractId,
          contractTypeId: contractType.id,
        },
        (status, res) => {
          setSaving(status);
          if (!status && !!res && !!refreshOnChange) {
            refreshOnChange();
            setChangeContractType(null);
            setContractType(null);
          }
        }
      );
    }
  };

  return (
    <>
      <Card
        className={`rounded hoverable-card mb-2 mt-2 pb-3`}
        variant="outlined"
        style={{
          border: "none",
        }}
      >
        <CardHeader
          className="pb-0 pt-2"
          avatar={
            <Tooltip title="Progress">
              <Box
                sx={{
                  position: "relative",
                  display: "inline-flex",
                  cursor: "default",
                }}
              >
                <CircularProgress
                  className={`text-${
                    score < 50
                      ? "danger"
                      : score < 70
                      ? "warning"
                      : score < 100
                      ? "info"
                      : "success"
                  }`}
                  variant="determinate"
                  value={score}
                />
                <Box
                  sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="caption"
                    component="div"
                    style={{ fontSize: "7px" }}
                    color="text.secondary"
                    className={`text-${
                      score < 50
                        ? "danger"
                        : score < 70
                        ? "warning"
                        : score < 100
                        ? "info"
                        : "success"
                    }`}
                  >
                    {`${score.toFixed(2)}%`}
                  </Typography>
                </Box>
              </Box>
            </Tooltip>
            // <Tooltip title={subordinate.names}>
            //   <Box
            //     sx={{
            //       position: "relative",
            //       display: "inline-flex",
            //       cursor: "default",
            //     }}
            //   >
            //     <Avatar
            //       sizes="large"
            //       style={{ border: "1px solid #d1cbcb" }}
            //       alt={subordinate.names}
            //       className=""
            //       src={
            //         subordinate.profileImage
            //           ? `data:image/jpeg;base64,${subordinate.profileImage}`
            //           : defaultProfile
            //       }
            //     />
            //   </Box>
            // </Tooltip>
          }
          title={
            <span className="d-flex flex-column">
              <span className="d-flex align-items-center text-uppercase font-weight-bold text-primary">
                <strong>{subordinate.no}:</strong> {subordinate.names}
                {!subordinate.competencyTotalScore &&
                  !!subordinate.numOfActivities &&
                  subordinate.numOfActivities ===
                    subordinate.scoredActivities && (
                    <span
                      className="badge badge-warning ml-1"
                      style={{
                        fontWeight: "bold !important",
                      }}
                    >
                      Competency not scored
                    </span>
                  )}
              </span>
              <span className="d-block text-primary ml-1 text-sm">
                {subordinate.positionName}{" "}
                <strong className="text-dark">
                  @{subordinate.unitName.toUpperCase()}
                </strong>
              </span>
            </span>
          }
          subheader={
            <span className="d-flex align-items-center flex-wrap justify-content-between ">
              <span className="d-flex align-items-center flex-wrap">
                <span className="">
                  <CustomProgressLine value={subordinate.totalScore} />

                  <span className="d-flex align-items-center  flex-wrap">
                    <span
                      className={`align-items-center px-1 mx-1 text-primary badge text-uppercase border badge-light font-weight-bold text-uppercase`}
                      style={{
                        cursor: "default",
                        borderRadius: "0px",
                      }}
                    >
                      {subordinate.numOfActivities} Items
                    </span>
                    <span
                      className={`d-flex align-items-center px-1 mx-1  text-dark text-uppercase badge badge-light`}
                      style={{
                        cursor: "default",
                        borderRadius: "8px",
                      }}
                    >
                      <span
                        className={`${
                          subordinate.ontrackActivities > 0
                            ? "badge badge-secondary"
                            : ""
                        } mr-1`}
                      >
                        {subordinate.ontrackActivities}
                      </span>
                      Ontrack
                    </span>
                    <span
                      className={`d-flex  align-items-center px-1 mx-1  text-dark text-uppercase badge badge-light`}
                      style={{
                        cursor: "default",
                        // borderRight: "2px solid #ccd0d6",
                        // borderLeft: "2px solid #ccd0d6",
                        borderRadius: "8px",
                      }}
                    >
                      <span
                        className={`${
                          subordinate.dueActivities > 0
                            ? "badge badge-warning"
                            : ""
                        } mr-1`}
                      >
                        {subordinate.dueActivities}
                      </span>
                      Due
                    </span>
                    <span
                      className={`d-flex align-items-center px-1 mx-1 text-dark text-uppercase badge badge-light`}
                      style={{
                        cursor: "default",
                        // borderRight: "2px solid #ccd0d6",
                        // borderLeft: "2px solid #ccd0d6",
                        // borderRadius: "8px",
                      }}
                    >
                      <span
                        className={`${
                          subordinate.reportedActivities > 0
                            ? "badge badge-primary"
                            : ""
                        } mr-1`}
                      >
                        {subordinate.reportedActivities}
                      </span>
                      Reported
                    </span>
                    <span
                      className={`d-flex align-items-center px-1 mx-1 text-dark text-uppercase badge badge-light`}
                      style={{
                        cursor: "default",
                        // borderRight: "2px solid #ccd0d6",
                        // borderLeft: "2px solid #ccd0d6",
                        // borderRadius: "8px",
                      }}
                    >
                      <span
                        className={`${
                          subordinate.scoredActivities > 0
                            ? "badge badge-success"
                            : ""
                        } mr-1`}
                      >
                        {subordinate.scoredActivities || 0}
                      </span>
                      Scored
                    </span>

                    <span
                      className={`d-flex align-items-center px-1 mx-1 text-dark text-uppercase badge badge-light`}
                      style={{
                        cursor: "default",
                        // borderRight: "2px solid #ccd0d6",
                        // borderLeft: "2px solid #ccd0d6",
                        // borderRadius: "8px",
                      }}
                    >
                      <span
                        className={`${
                          subordinate.rejectedActivities > 0
                            ? "badge badge-danger"
                            : ""
                        } mr-1`}
                      >
                        {subordinate.rejectedActivities || 0}
                      </span>{" "}
                      Rejected
                    </span>

                    <span
                      className={`d-flex align-items-center  text-${
                        (subordinate.targetAchieved * 100) /
                          (subordinate.target || 1) <
                        50
                          ? "danger"
                          : (subordinate.targetAchieved * 100) /
                              (subordinate.target || 1) <
                            70
                          ? "warning"
                          : (subordinate.targetAchieved * 100) /
                              (subordinate.target || 1) <
                            90
                          ? "info"
                          : "success"
                      } px-2 py-0 ml-2`}
                      style={{
                        border: "none",
                        cursor: "default",
                        fontWeight: "lighter",
                        fontSize: "13px",
                      }}
                    >
                      <span
                        className={`badge badge-${
                          (subordinate.targetAchieved * 100) /
                            (subordinate.target || 1) <
                          50
                            ? "danger"
                            : (subordinate.targetAchieved * 100) /
                                (subordinate.target || 1) <
                              70
                            ? "warning"
                            : (subordinate.targetAchieved * 100) /
                                (subordinate.target || 1) <
                              90
                            ? "info"
                            : "success"
                        } mr-1`}
                      >
                        {subordinate.targetAchieved}%
                      </span>
                      Target achieved
                    </span>
                  </span>
                </span>
              </span>
            </span>
          }
          action={
            <Box className="d-flex align-items-center">
              <span className="mt-3 text-center">
                <span className="text-center d-block">
                  <span className="d-block">
                    <span className="d-flex align-items-center">
                      {!!subordinate.numOfActivities && (
                        <span>
                          <DownloadEmployeeRBMReport
                            title={
                              !subordinate.contractId
                                ? "Employee doesn't have RBM Contract"
                                : "Download Employee Performance Report"
                            }
                            downloadEmployeePerformanceReport={
                              downloadEmployeePerformanceReport
                            }
                            downloadEmployeeContractReport={
                              downloadEmployeeContractReport
                            }
                            disabled={!subordinate.contractId || loading}
                            employee={{
                              id: subordinate.employeeId || subordinate.id,
                              contractTypeName: subordinate.contractTypeName,
                              contractId: subordinate.contractId,
                            }}
                            selectedFiscalYear={selectedFiscalYear}
                          />
                          {/* <IconButton
                              disabled={!subordinate.contractId}
                              color="primary"
                              size="small"
                              onClick={() =>
                                downloadEmployeeContractReport(
                                  subordinate?.contractId
                                )
                              }
                            >
                              <i className="fas fa-download"></i>
                            </IconButton> */}
                        </span>
                      )}

                      {!!subordinate.numOfActivities &&
                        !!subordinate.contractTypeName && (
                          <span className="badge badge-pill">
                            <small>
                              {subordinate.contractTypeName} <br />
                              contract
                            </small>
                            {!subordinate.isNotActive && (
                              <Tooltip title="Edit contract type">
                                <IconButton
                                  aria-label="edit-contract-type"
                                  size="small"
                                  onClick={() =>
                                    setChangeContractType(subordinate)
                                  }
                                >
                                  <ModeEditOutlineRoundedIcon fontSize="inherit" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </span>
                        )}

                      {!subordinate.numOfActivities && (
                        <span
                          style={{ color: "#dc3545" }}
                          className=" badge badge-pill"
                        >
                          <span className="text-danger">No contract</span>
                        </span>
                      )}

                      {!!subordinate.numOfActivities && (
                        <button
                          disabled={
                            loading
                            // || env !== "local"
                          }
                          onClick={() => setShowContractItemsDialog(true)}
                          className="ml-2 py-0 btn btn-primary btn-sm"
                        >
                          <OpenInNewIcon /> Evaluate
                        </button>
                      )}
                    </span>
                  </span>
                </span>
              </span>
            </Box>
          }
        />
      </Card>
      <Divider />
      <Divider />

      {showContractItemsDialog && (
        <ContractDetailsDialog
          open={showContractItemsDialog}
          onClose={() => setShowContractItemsDialog(false)}
          selectedSubordinate={subordinate}
        />
      )}

      {showContractDialog && (
        <ContractForm
          showDialog={showContractDialog}
          setShowDialog={setShowContractDialog}
          subordinate={subordinate}
        />
      )}

      {!!changeContractType && (
        <Dialog
          aria-labelledby="customized-dialog-title"
          open={true}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle>
            <Typography
              component="div"
              className="d-flex align-items-center justify-content-start text-uppercase"
              style={{
                fontSize: "14px",
              }}
            >
              <span className="font-weight-bold mr-1">Change RBM Contract</span>
              <ArrowRightIcon className="text-primary" />
              {changeContractType.names}
            </Typography>

            <IconButton
              aria-label="close"
              onClick={() => {
                setChangeContractType(null);
                setContractType(null);
              }}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <span className="material-icons">close</span>
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <div style={{ minHeight: "125px" }}>
              <div className="d-flex align-items-center mb-3">
                <span className="font-weight-bold mr-2">
                  Current Contract Type:
                </span>
                <span>{changeContractType.contractTypeName}</span>
              </div>

              <Autocomplete
                disablePortal
                size="small"
                value={contractType}
                options={[
                  {
                    id: 1,
                    name: "Normal",
                  },
                  {
                    id: 2,
                    name: "Acting",
                  },
                  {
                    id: 3,
                    name: "Probation",
                  },
                  {
                    id: 4,
                    name: "Second Probation",
                  },
                ].filter(
                  (item) => item.id !== changeContractType.contractTypeId
                )}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                  setContractType(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Contract Type"
                    placeholder="Contract Type"
                  />
                )}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.name}
                  </Box>
                )}
              />
            </div>
          </DialogContent>
          <DialogActions className="d-flex justify-content-center pb-4">
            <Button
              disabled={loading || !contractType || saving}
              color="primary"
              variant="contained"
              onClick={saveChange}
              className="ml-2 px-5"
            >
              {loading ? "Wait..." : "Update"}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

const mapStateToProps = ({ user, loading, selectedFiscalYear }) => {
  return { user, loading, selectedFiscalYear };
};
export default connect(mapStateToProps, {
  deleteIndicator,
  approveIndicator,
  getIndicatorAssignments,
  downloadEmployeeContractReport,
  downloadEmployeePerformanceReport,
  changeRBMContractType,
})(SubordinateCard);
